import TrainingFacilities from './page';
import { RouterConfig } from 'router/AppRoute';
import paths from 'helper/pathRoutes';

const routes: RouterConfig[] = [
  {
    path: paths.trainingFacilities,
    page: TrainingFacilities,
  },
];

export default routes;
